// TODO GUI-4239 Remove when LV and LT retire the Russian language requirement by law.

import { Country, LanguageLong } from './enums';

type CountryLanguageKey = `${Country}:${LanguageLong}`;
type CountryLanguageMap = Map<CountryLanguageKey, boolean>;

/**
 * Key format: `{COUNTRY}:{LANGUAGE}`, e.g. `"LV:RUS"`.
 * Defaults to `true` (allowed) for any combination not explicitly set.
 */
const languageFlags: CountryLanguageMap = new Map<CountryLanguageKey, boolean>([
    [`${Country.Latvia}:${LanguageLong.Russian}`, true],
    [`${Country.Lithuania}:${LanguageLong.Russian}`, true],
]);

const flagKey = (
    country: Country,
    language: LanguageLong
): CountryLanguageKey => `${country}:${language}`;

/**
 * Feature flags for the UI Library.
 * A lightweight mechanism for toggling behavior without a full config system.
 * @memberof Helpers
 */
export const featureFlags = {
    /**
     * Enables or disables a specific language for a given country.
     * @param {Country} country
     * @param {LanguageLong} language
     * @param {boolean} value
     */
    setLanguageInCountry(
        country: Country,
        language: LanguageLong,
        value: boolean
    ): void {
        languageFlags.set(flagKey(country, language), value);
    },

    /**
     * Returns whether a language is allowed for a given country.
     * Defaults to `true` for unknown combinations.
     * @param {Country} country
     * @param {LanguageLong} language
     * @returns {boolean}
     */
    hasLanguageInCountry(country: Country, language: LanguageLong): boolean {
        return languageFlags.get(flagKey(country, language)) ?? true;
    },
};
